import React from 'react';
import PropTypes from 'prop-types';

import AbsentDataComponent from '../../../components/GeneralComponents/AbsentData/AbsentDataComponent';
import { FormattedMessage } from 'react-intl';
import './ShiftRecordsTable.scss';
import UserTable from 'pages/RequestsTab/shared/UserTable/UserTable';
import constants from 'pages/RequestsTab/constants';
import Summary from 'pages/RequestsTab/shared/Summary/Summary';
import Header from 'pages/RequestsTab/shared/Header/Header';
import filterUtil from 'pages/RequestsTab/duck/filter';
import utils from 'pages/RequestsTab/duck/utils';
import { cloneDeep } from 'lodash';

class ShiftRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    const { categoryTypes } = constants;
    this.state = {
      headers: props.headers ? props.headers : [],
      selectedType: categoryTypes.REQUESTS,
      selectedIndex: 0,
      selectedItem: null,
      selectedSort: null,
      searchTerm: '',
    };
  }

  componentDidMount() {

  }

  checkForAbsentData = (foundShifts) => {
    if (!this.props.loading && foundShifts.length === 0) {
      return (
        <AbsentDataComponent message=<FormattedMessage
          id="CalendarTable.noData"
          defaultMessage="There is no data available for the condition set." />
        />
      );
    }
  };

  createCategoryItems = (recordRows) => {
    const { enableVto } = this.props;
    const rowsToCount = enableVto === false
      ? recordRows.filter(item => !item || item.name !== 'shift_vto')
      : recordRows;
    // Initialize counts for different categories
    let totalCount = 0;
    let openShiftsCount = 0;
    let teamShiftsCount = 0;
    let vtoShiftsCount = 0;

    // Go through each item to count categories
    rowsToCount.forEach(item => {
      if (item) {
        totalCount++; // Count total items

        if (item.time_off_reason === undefined) { // It's a shift
          if (item.name === 'open_shift') {
            openShiftsCount++; // Count open shifts
          } else if (item.name === 'shift') {
            teamShiftsCount++; // Count team shifts
          } else if (enableVto !== false && item.name === 'shift_vto') {
            vtoShiftsCount++; // Count voluntary time off
          }
        }
      }
    });

    // Prepare the output items (omit VTO when disabled for location)
    const requestItems = [
      { name: <FormattedMessage id="Requests.all" defaultMessage="All" />, value: totalCount },
      { name: <FormattedMessage id="Requests.openShifts" defaultMessage="Open Shifts" />, value: openShiftsCount },
      { name: <FormattedMessage id="Requests.teamShifts" defaultMessage="Team Shifts" />, value: teamShiftsCount },
      ...(enableVto !== false ? [{ name: <FormattedMessage id="Requests.vtos" defaultMessage="Voluntary Time Off" />, value: vtoShiftsCount }] : []),
    ];

    return [{ id: 'requests', items: requestItems }];
  }

  categorySelected = (selectedType) => {
    this.setState({ selectedType: selectedType });
  };

  createSummaryElements = (categoryItems) => {
    const { selectedType, } = this.state;
    const { categoryTypes } = constants;
    if (selectedType === categoryTypes.REQUESTS) {
      const idxL = categoryItems.findIndex((el) => el.id === 'requests');
      if (idxL >= 0) {
        return categoryItems[idxL].items;
      }
    }
  };

  summaryItemSelected = (index, item) => {
    this.setState({ selectedItem: item, selectedIndex: index });
  };

  notifySortTypeChanged = (type) => {
    this.setState({ selectedSort: type })
  }

  notifySearchTermChanged = (searchTerm) => {
    this.setState({ searchTerm: searchTerm });
  }

  notifyDropDownOpened = (opened) => {
    this.setState({ popupOpened: opened });
  }

  notifyFiltersSelected = (dept, status, email, employeeId, group, jobTitle, skill, weekday) => {
    this.setState({ filterByDepartment: dept, filterByStatus: status, filterByGroup: group, filterByJobTitle: jobTitle, filterByEmail: email, filterByEmployeeId: employeeId, filterBySkill: skill, filterByWeekday: weekday });
  }

  filterShifts = (type, index, shiftRecords) => {
    const { categoryTypes } = constants;
    const { enableVto } = this.props;

    // Determine the total shifts based on the type
    let total = (type === categoryTypes.REQUESTS) ? cloneDeep(shiftRecords) : [];

    // Initialize filtered shifts
    let filtered = [];

    // Use a single loop to filter based on type and index (index 3 = VTO only when enableVto)
    total.forEach(idxObject => {
      if (idxObject) {
        const isShift = idxObject.time_off_reason === undefined;
        if (type === categoryTypes.REQUESTS) {
          if (index === 0) {
            filtered.push(idxObject); // All shifts
          } else if (index === 1 && isShift && idxObject.name === 'open_shift') {
            filtered.push(idxObject); // Open shifts
          } else if (index === 2 && isShift && (idxObject.name === 'shift' || idxObject.name === 'shift_inventory')) {
            filtered.push(idxObject); // Team shifts
          } else if (enableVto !== false && index === 3 && isShift && idxObject.name === 'shift_vto') {
            filtered.push(idxObject); // Voluntary time off
          }
        }
      }
    });

    console.log('ShiftRecordsTable: ', filtered);
    return filtered;
  };

  visibleShifts = (shifts) => {
    const { selectedSort, ascending, filterBySkill, filterByDepartment, filterByStatus, filterByWeekday, filterByGroup, filterByJobTitle, filterByEmail, filterByEmployeeId, selectedType, selectedIndex } = this.state;
    const { enableVto } = this.props;
    const shiftsToShow = enableVto === false
      ? shifts.filter(s => !s || s.name !== 'shift_vto')
      : shifts;
    const shiftsOfCurrentCategory = this.filterShifts( selectedType, selectedIndex, shiftsToShow);
    const shiftsWithFiltersApplied = filterUtil.applyFiltersToShifts(shiftsOfCurrentCategory, filterByDepartment, filterByStatus, filterByGroup, filterByJobTitle, filterByEmail, filterByEmployeeId, filterBySkill, filterByWeekday, false,);
    const sortedShifts = utils.sortShifts(shiftsWithFiltersApplied, selectedSort?.name, ascending);
    return sortedShifts;
  }

  render() {
    const { selectedType, selectedIndex, selectedItem } = this.state;
    const { shifts, loading, locationSettings, skills, notifyRefreshRequested, locationId, stateFilters, updateRowData, enableVto } = this.props;

    const categoryItems = this.createCategoryItems(shifts);
    const summaryItems = this.createSummaryElements(categoryItems);
    const foundShifts = this.visibleShifts(shifts);

    return (
      <div className="schedule-calendar__wrap">

        <Summary
          loading={this.props.loading}
          summaryItems={summaryItems}
          selectedType={selectedType}
          parentSelectedIndex={selectedIndex}
          selectedShifts={[]}
          summaryItemSelected={this.summaryItemSelected}
        />

        <Header
          locationSettings={locationSettings}
          selectedType={selectedType}
          locationId={locationId}
          isRequests={false}
          filteredResults={foundShifts}
          selectedShifts={[]}
          selectedItem={selectedItem}
          notifyRefreshRequested={notifyRefreshRequested}
          notifyDropDownOpened={this.notifyDropDownOpened}
          notifyFiltersSelected={this.notifyFiltersSelected}
          notifySearchTermChanged={this.notifySearchTermChanged}
          notifySortTypeChanged={this.notifySortTypeChanged}
        />

        <UserTable
          loading={loading}
          isRequests={false}
          locationId={locationId}
          filteredResults={foundShifts}
          skills={skills} />

        {this.checkForAbsentData(foundShifts)}
      </div>
    );
  }
}

export default ShiftRecordsTable;

ShiftRecordsTable.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
    })
  ),
  shifts: PropTypes.array.isRequired,
  enableVto: PropTypes.bool,
};

ShiftRecordsTable.defaultProps = {
  enableVto: true,
};
